export default __webpack_public_path__ + "static/media/affligem_l2.05c172a9.png";